<template>
    <GChart type="LineChart" :data="chartData" :options="options" />
  </template>
  
  <script>
  import { GChart } from 'vue-google-charts'
  
  export default {
    components: { GChart },
  
    props: { data: Array },
  
    computed: {
      chartData() {
        return [
          ['Month', 'Revenue', 'Expense'],
          ...(this.data || []).map(i => [
            i.month,
            Number(i.income),
            Number(i.expense)
          ])
        ]
      }
    },
  
    data() {
      return {
        options: { height: 300 }
      }
    }
  }
  </script>